import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-brand-red text-white shadow-sm",
        secondary:
          "border-transparent bg-brand-yellow text-black hover:bg-brand-yellow/90",
        destructive:
          "border-transparent bg-secondary-burgundy text-white hover:bg-secondary-burgundy/90",
        outline: "text-foreground border-brand-yellow/50 hover:bg-accent-yellow/10",
        success:
          "border-transparent bg-accent-green/20 text-accent-green",
        warning:
          "border-transparent bg-brand-yellow/20 text-brand-yellow-700",
        info:
          "border-transparent bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
